import React, { useState, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import ReactGA from 'react-ga4';
// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import ReactPixel from 'react-facebook-pixel';
// import { Fireworks } from '@fireworks-js/react';
// hooks
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import DailyCheckInButton from '../../views/promotion/DailyCheckInButton';
import useSettings from '../../hooks/useSettings';
import useResponsive from '../../hooks/useResponsive';
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// config
import { HEADER, NAVBAR } from '../../config';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import useAuth from '../../hooks/useAuth';

//
import DashboardHeader from './header';
import NavbarVertical from './navbar/NavbarVertical';
import NavbarHorizontal from './navbar/NavbarHorizontal';
import Footer from './Footer';

import { callMultipleRequests, getGameCategsAndCompanies, getUserMemberBalance } from '../../redux/slices/lookup';
import { setOpenHistory, setOpenMyDownline } from '../../redux/slices/profilePages';

import { setGameCategories } from '../../redux/slices/game';

import conObj from '../../utils/connection-assistant';

import { usePageVisibility } from '../../hooks/usePageVisibility';
import MobileBottomNav from './navbar/MobileBottomNav';
import { closeLoadingScreen, openLoadingScreen } from '../../redux/slices/settings';
import AccountDrawer from './navbar/AccountDrawer';
import SpinWheelButton from '../../views/promotion/SpinWheelButton';
import CustomModal from '../../components/CustomModal';
import TransactionHistory from '../../views/history/TransactionHistory';
import { isTawkToScriptSrc } from '../../utils/formatString';

// ----------------------------------------------------------------------

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})(({ showDownloadApp, isDesktop, collapseClick, theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT,
  // paddingBottom: '64px',
  backgroundColor: '#000',
  [theme.breakpoints.only('xs')]: {
    // paddingTop: HEADER.MOBILE_HEIGHT,
  },
  [theme.breakpoints.only('xs')]: {
    paddingTop: showDownloadApp && !isDesktop ? HEADER.MOBILE_HEIGHT + 36 : HEADER.MOBILE_HEIGHT,
  },
  [theme.breakpoints.up('lg')]: {
    // paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));
// ----------------------------------------------------------------------

function checkIsObjectEmpty(obj) {
  return typeof obj === 'object' && obj !== null && Object.keys(obj).length === 0;
}

const DashboardLayout = () => {
  const { isAuthenticated } = useAuth();

  const { collapseClick, isCollapse, onToggleCollapse } = useCollapseDrawer();

  const { siteSettings, userProfile } = useSelector((x) => x.lookup);

  const { isOpenHistory, isOpenMyDownline } = useSelector((x) => x.profilePages);

  const isVisible = usePageVisibility();

  const dispatch = useDispatch();

  const { themeLayout } = useSettings();

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const [openAccountDrawer, setOpenAccountDrawer] = useState(false);

  // const [showFireworks, setShowFireworks] = useState(true);

  const [tawkToCreds, setTawkToCreds] = useState({
    propertyId: '',
    widgetId: '',
  });

  const tawkMessengerRef = useRef();

  const [showDownloadApp, setShowDownloadApp] = useState(true);

  const verticalLayout = themeLayout === 'vertical';

  const initBalanceCall = useRef(true);

  useEffect(() => {
    // setTimeout(() => setShowFireworks(false), 30000);

    // getAngPauPromotion();

    // // Check if the PWA is already installed (usually stored in localStorage or can be checked with appinstalled event)
    // if (window.matchMedia('(display-mode: standalone)').matches) {
    //   setShowDownloadApp(false);
    // }

    // // Listen for the `appinstalled` event
    // window.addEventListener('appinstalled', () => {
    //   setShowDownloadApp(false);
    // });

    // Call api if pixel tracking localstorage exists
    const storagePixelId = localStorage.getItem('pixelId');
    const storagePixelClickId = localStorage.getItem('pixelClickId');
    if (storagePixelId && storagePixelClickId) {
      conObj
        .post(`members/adtracker_pageview.json?pixel_id=${storagePixelId}&pixel_click_id=${storagePixelClickId}`)
        .finally(() => {
          localStorage.removeItem('pixelId');
        });
    }

    callMultipleRequests().finally(() => {
      initBalanceCall.current = false;
    });
    const promises = [getGameCategsAndCompanies(), getAllGames()];

    // if (isAuthenticated) getUserMemberBalance();

    dispatch(openLoadingScreen());
    Promise.all(promises).finally(() => dispatch(closeLoadingScreen()));

    // return () => {
    //   window.removeEventListener('appinstalled', () => {
    //     setShowDownloadApp(false);
    //   });
    // };
  }, []);

  /**
   * Call getUserMemberBalance() when tab is active and isAuthenticated
   * to keep the member balance updated
   */
  useEffect(() => {
    if (isVisible && isAuthenticated && !initBalanceCall.current) getUserMemberBalance();
  }, [isVisible, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && !checkIsObjectEmpty(userProfile)) {
      triggerSuccessDepositEvent();
    }
  }, [isAuthenticated, userProfile]);

  useEffect(() => {
    try {
      if (siteSettings?.config_analytics) {
        const _ga = siteSettings?.config_analytics?.split(',');

        // Multiple products (previously known as trackers)
        ReactGA.initialize(
          _ga.map((item) => ({
            // measurement ID
            trackingId: item,
            // gaOptions: {...}, // optional
            // gtagOptions: {...}, // optional
          }))
          //   [
          //   {
          //     // measurement ID
          //     trackingId: _ga[0],
          //     // gaOptions: {...}, // optional
          //     // gtagOptions: {...}, // optional
          //   },
          // ]
        );
      }

      if (siteSettings?.config_livechat && isTawkToScriptSrc(siteSettings?.config_livechat)) {
        // const respondIo = JSON.parse(siteSettings?.config_livechat);
        // const script = document.createElement('script');
        // script.id = respondIo?.id;
        // script.src = respondIo?.src;
        // script.async = true;
        // document.head.appendChild(script);

        const splitUrl = siteSettings.config_livechat.split('/');

        if (splitUrl?.length) {
          setTawkToCreds({
            propertyId: splitUrl[splitUrl.length - 2],
            widgetId: splitUrl[splitUrl.length - 1],
          });
        }
      }

      if (siteSettings?.config_fb_pixel) {
        const metaPixel = siteSettings.config_fb_pixel.replace(/[^\d,]+/g, '').split(',');
        const options = {
          autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
          debug: false, // enable logs
        };

        metaPixel.forEach((_pixel) => {
          ReactPixel.init(_pixel, options);

          ReactPixel.pageView(); // For tracking page view
        });
      }

      // Optional cleanup
      // return () => {
      //   document.body.removeChild(script);
      // };
    } catch (error) {
      console.warn(`3RD PARTY INTEGRATION ERROR: ${error?.message}`);
    }
  }, [siteSettings]);

  const getAllGames = () => {
    conObj.post('games/all.json?limit=1').then((res) => {
      if (res.status === 200) {
        // res.data?.data?.data
        // set appversion to localstorage
        // res.data?.data.appversion
        const _allGames = res.data?.data?.data;

        dispatch(
          setGameCategories(
            _allGames
              .filter((f) => f.key.toLowerCase().indexOf('gcat') !== -1)
              .map((item) => ({ key: item.key, name: item.name, slug: item.slug }))
          )
        );
      }
    });
  };

  /**
   * Trigger only for 1st & 2nd time Success Deposit
   */
  const triggerSuccessDepositEvent = () => {
    const requestData = {
      'named-is_deposit': 'deposit',
      'named-is_tracking_event_fired': 'false',
      'named-transaction_status': 'approved',
    };
    conObj
      .post(`transactions/index.json?page=1&limit=5&sort_direction=desc`, requestData)
      .then((res) => {
        if (res.status === 200) {
          if (res.data?.data?.status === 1) {
            // const toTriggerSuccessDepositEventList = res.data?.data?.data?.filter(f => f?.transaction_status === 'Approved' && !f?.is_tracking_event_fired && f?.date > "19-12-2024");
            const toTriggerSuccessDepositEventList = res.data?.data?.data;

            if (toTriggerSuccessDepositEventList?.length > 0) {
              toTriggerSuccessDepositEventList.forEach((depositToFire) => {
                /**
                 * Affiliate
                 */
                if (userProfile?.tracking_pixel_id) {
                  // Trigger as Purchase as well
                  ReactPixel.trackSingleCustom(userProfile?.tracking_pixel_id, 'Purchase', {
                    value: depositToFire?.amount?.value,
                    source: 'affiliate',
                  });
                  // now mark it as triggered true in DB
                  conObj.post(`transactions/tracking_event_fired/${depositToFire?.id}.json`);
                }

                /**
                 * Main
                 */
                if (siteSettings?.config_fb_pixel) {
                  const metaPixel = siteSettings.config_fb_pixel.replace(/[^\d,]+/g, '').split(',');

                  // Fire only for the main to prevent duplicate
                  if (metaPixel?.length > 0) {
                    ReactPixel.trackSingleCustom(metaPixel[0], 'Purchase', {
                      value: depositToFire?.amount?.value,
                      source: 'main',
                    });

                    // now mark it as triggered true in DB
                    conObj.post(`transactions/tracking_event_fired/${depositToFire?.id}.json`);
                  }
                }
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(`Error: ${err.message}`);
      });
  };

  if (verticalLayout) {
    return (
      <>
        <DashboardHeader
          onOpenSidebar={() => setOpen(true)}
          verticalLayout={verticalLayout}
          showDownloadApp={showDownloadApp}
          setShowDownloadApp={setShowDownloadApp}
        />

        {isDesktop ? (
          <NavbarHorizontal />
        ) : (
          <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
        )}

        <Box
          component="main"
          sx={{
            px: { lg: 2 },
            pt: {
              xs: `${HEADER.MOBILE_HEIGHT + 24}px`,
              lg: `${HEADER.DASHBOARD_DESKTOP_HEIGHT + 80}px`,
            },
            pb: {
              xs: `${HEADER.MOBILE_HEIGHT + 24}px`,
              lg: `${HEADER.DASHBOARD_DESKTOP_HEIGHT + 24}px`,
            },
          }}
        >
          <Outlet />
        </Box>
      </>
    );
  }

  return (
    <>
      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
          // backgroundColor: '#0b1712',
        }}
      >
        <DashboardHeader
          isCollapse={isCollapse}
          isOpenSidebar={open}
          onOpenSidebar={() => setOpen(true)}
          onCloseSidebar={() => setOpen(!open)}
          onToggleCollapse={onToggleCollapse}
          openAccountDrawer={openAccountDrawer}
          setOpenAccountDrawer={setOpenAccountDrawer}
          showDownloadApp={showDownloadApp}
          setShowDownloadApp={setShowDownloadApp}
        />

        <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

        <MainStyle collapseClick={collapseClick} showDownloadApp={showDownloadApp} isDesktop={isDesktop}>
          {/* <img src={require('../../assets/bg.png')} style={{ position: 'absolute' }} alt="" /> */}
          <Outlet />

          <SpinWheelButton
            sx={{
              position: 'fixed',
              right: '5px',
              bottom: { xs: '80px', sm: '80px', md: '15%' },
              zIndex: 9,
            }}
          />

          {isAuthenticated && (
            <DailyCheckInButton
              sx={{
                position: 'fixed',
                right: '5px',
                bottom: { xs: '80px', sm: '80px', md: '15%' },
                zIndex: 999,
              }}
            />
          )}

          <Footer />
          {/* BOTTOM NAVIGATION */}
          {!isDesktop && isAuthenticated !== null && (
            <MobileBottomNav
              isAuthenticated={isAuthenticated}
              openAccountDrawer={openAccountDrawer}
              setOpenAccountDrawer={setOpenAccountDrawer}
              tawkRef={tawkMessengerRef}
            />
          )}
          {/* BOTTOM NAVIGATION */}
          {/* ACCOUNT DRAWER  */}
          {isAuthenticated !== null && <AccountDrawer open={openAccountDrawer} setOpen={setOpenAccountDrawer} />}
          {/* ACCOUNT DRAWER  */}
        </MainStyle>

        {/* {siteSettings?.config_livechat && siteSettings?.config_livechat?.length === 8 ? ( */}
        {tawkToCreds?.propertyId && tawkToCreds?.widgetId ? (
          // <LiveChatWidget
          //   license={siteSettings?.config_livechat}
          //   onReady={(data) => {
          //     const widgetContainer = document.getElementById('chat-widget-container');

          //     if (widgetContainer && data.state.visibility === 'minimized') {
          //       widgetContainer.classList.add('adjust-bottom-space');
          //     }
          //   }}
          //   onVisibilityChanged={(data) => {
          //     const widgetContainer = document.getElementById('chat-widget-container');

          //     if (widgetContainer) {
          //       if (data.visibility === 'maximized') {
          //         widgetContainer.classList.remove('adjust-bottom-space');
          //       } else widgetContainer.classList.add('adjust-bottom-space');
          //     }
          //   }}
          // />
          <TawkMessengerReact
            {...tawkToCreds}
            ref={tawkMessengerRef}
            onBeforeLoad={() => {
              if (!isDesktop) {
                tawkMessengerRef.current.hideWidget();
              } else {
                tawkMessengerRef.current.showWidget();
              }
            }}
          />
        ) : (
          <></>
        )}
      </Box>
      {/* {showFireworks && (
        <Fireworks
          options={{ speed: 3, explosion: 5 }}
          style={{
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            position: 'fixed',
            pointerEvents: 'none',
            zIndex: 1200,
          }}
        />
      )} */}

      {isOpenHistory && (
        <CustomModal maxWidth="xs" open={isOpenHistory} onClose={() => dispatch(setOpenHistory(false))}>
          <TransactionHistory />
          {/* <Stack sx={{ py: 5, px: 4, alignItems: 'center' }} spacing={2}>
            <Card sx={{ bgColor: 'white' }}>
              <Image src={showBankQrCode?.qrcode_photo_url} />
            </Card>

            <Typography textAlign={'center'}>{showBankQrCode?.label}</Typography>
          </Stack> */}
        </CustomModal>
      )}
    </>
  );
};

export default DashboardLayout;
